export function renderMarketsColumnsFilter(markets, columns) {
    var marketsTrimmed = markets;
    Object.keys(columns).forEach(function (key) {
        columns[key] && (marketsTrimmed = markets.slice(0, parseInt(key)));
    });
    return marketsTrimmed;
}
//# sourceMappingURL=renderMarketsColumnsFilter.js.map